import { render, staticRenderFns } from "./Card3.vue?vue&type=template&id=6db9a3b6&"
import script from "./Card3.vue?vue&type=script&lang=js&"
export * from "./Card3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports